import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconShowMore: IconType = () => (
  <Svg viewBox="0 0 24 24">
    <path
      d="M20.4627 24L11.7694 15.0365C8.51909 17.2477 4.17348 16.5637 1.71082 13.4533C-0.751833 10.3429 -0.532574 5.81527 2.21833 2.97338C4.97361 0.135423 9.36458 -0.0916678 12.3814 2.44777C15.3982 4.98721 16.0618 9.46914 13.9174 12.8213L22.6077 21.7863L20.4627 24ZM7.58476 3.81282C5.41294 3.8114 3.54257 5.39226 3.11749 7.58863C2.6924 9.78501 3.83099 11.9852 5.83694 12.8436C7.84289 13.7021 10.1575 12.9798 11.3653 11.1184C12.5732 9.25696 12.3378 6.77493 10.8031 5.19014C9.95179 4.30615 8.79287 3.81018 7.58476 3.81282ZM24.1152 10.0092H21.1003V6.90013H18.0855V3.79107H21.1003V0.682007H24.1152V3.79107H27.13V6.90013H24.1152V10.0092Z"
      fill="currentColor"
    />
  </Svg>
)
